import { useT, useLanguage } from "../i18n/hooks.ts";

const SOURCE_URL_ES =
  "https://www.miteco.gob.es/es/cartografia-y-sig/ide/descargas/agua/cuencas-y-subcuencas.html";
const SOURCE_URL_EN =
  "https://www.miteco.gob.es/en/cartografia-y-sig/ide/descargas/agua/cuencas-y-subcuencas.html";

/**
 * Formal attribution — shown for as long as either MITECO reference layer
 * (SubBasinsPanel.tsx's "Add from MITECO" mode) is actually on screen, same
 * "persistent, not a one-off dialog" spirit as ExampleBanner.tsx. MITECO's
 * own terms (see the source page) are free use conditional on citing MITECO
 * as author/owner — this is that citation, not just a courtesy credit.
 */
export function MitecoAttributionBanner({ layer }: { layer: "basins" | "subBasins" }) {
  const t = useT();
  const language = useLanguage();
  const kind = t(
    layer === "basins"
      ? "mitecoAttributionBanner.basinsType"
      : "mitecoAttributionBanner.subBasinsType"
  );
  return (
    <div className="miteco-attribution-banner">
      <span>{t("mitecoAttributionBanner.warning", { kind })}</span>
      <a
        href={language === "es" ? SOURCE_URL_ES : SOURCE_URL_EN}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("mitecoAttributionBanner.viewSource")}
      </a>
    </div>
  );
}
